import React from 'react'

import { type PixelExperimentTracker } from '@lib/services/experiments/pixel-tracker'

export const PixelTrackerContext = React.createContext<PixelExperimentTracker>({
  trackAssignment: () => {},
  generatePixelUrl: () => null,
  getAssignedExperimentNames: () => [],
})
